import { Component, DoCheck, EventEmitter, Input, OnInit, Optional, Output, Self } from '@angular/core';
import { FormControl, NgControl, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'input-radio',
  templateUrl: './input-radio.component.html',
  styleUrls: ['./input-radio.component.scss']
})
export class InputRadioComponent implements ControlValueAccessor, DoCheck {

  @Input() type = 'radio-column';
  @Input() data: Array<IdNumberAndDescription> = []
  @Input() label: string = null
  @Input() mxDisabled = null;
  @Output() change = new EventEmitter<any>();
  @Input() value = null

  isRequired = false;

  // tslint:disable-next-line:variable-name
  onChange = (_value: any) => { };
  onTouched = () => { };
  _value: any;
  text: string;

  constructor(@Optional() @Self() public controlDir: NgControl) {
    // bind the CVA to our control
    if (controlDir) {
      controlDir.valueAccessor = this;
    }
  }

  writeValue(value: any): void {
    this._value = value;
    if (typeof value === 'string') {
      this.text = value;
    }

    this.onChange(this._value);
    this.change.emit(this._value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.mxDisabled = disabled;
  }

  ngDoCheck() {
    if (this.controlDir && this.controlDir.control instanceof FormControl) {
      // check if this field is required or not to display a 'required label'
      const validator =
        this.controlDir.control.validator &&
        this.controlDir.control.validator(new FormControl(''));
      this.isRequired = Boolean(validator && validator.hasOwnProperty('required'));
      this.mxDisabled = Boolean(this.controlDir.control.disabled);
    }
  }

}

export interface IdNumberAndDescription {

  id: number;
  description: string;

}
